// Modal.js
import React from "react";
import { X } from "lucide-react"; // or any icon library you use
import PropTypes from "prop-types";

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  variant = "default", // "login", "alert", "data"
  size = "md", // "sm", "md", "lg"
  dialogClass = "",
}) => {
  if (!isOpen) return null;

  // Map sizes to CSS classes
  const sizeClass = {
    sm: "modal__dialog--sm",
    md: "modal__dialog--md",
    lg: "modal__dialog--lg",
  }[size];

  return (
    <div className="modal">
      <div className={`modal__dialog ${sizeClass} ${dialogClass}`}>
        <div className="modal__header">
          {title && <div className="modal__title">{title}</div>}

          {/* Close button in header for login variant */}
          {variant === "login" && (
            <button onClick={onClose} className="modal__close">
              <X size={24} />
            </button>
          )}
        </div>

        <div className="modal__body">
          {children}

          {/* Close button in body for alert variant */}
          {variant === "alert" && (
            <button onClick={onClose} className="modal__close-body">
              <X size={24} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
  variant: PropTypes.oneOf(["default", "login", "alert", "data"]),
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  dialogClass: PropTypes.string,
};

export default Modal;
